import { Template } from 'modules/core/domain/interfaces/supabase/overlay/entity';
import { selectActiveTemplate, selectActiveTemplateId } from 'modules/template-editor/store/templates/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useOwnerBoardTemplates } from './use-owner-board-templates';

/**
 * Активный шаблон редактора табло: сначала список организации из кэша RTK Query, иначе слайс — там шаблоны
 * каталога и шаблон, который загрузила трансляция (`fetchTemplateWithBoards`). Трансляция этот хук не зовёт и
 * читает слайс напрямую (`useTemplates`).
 */
export function useActiveBoardTemplate(): Template | undefined {
  const activeTemplateId = useSelector(selectActiveTemplateId);
  const fromSlice = useSelector(selectActiveTemplate);
  const { templates } = useOwnerBoardTemplates();

  return useMemo(
    () => templates.find((template) => template.id === activeTemplateId) ?? fromSlice,
    [activeTemplateId, fromSlice, templates],
  );
}
